import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const UnmergeContactModal = React.lazy(() => import("./unmerge-contact.modal"));

const UnmergeContact: iModalProps<
  typeof UnmergeContactModal,
  {
    contactId: string;
    onUnmerged?: () => void;
  }
> = {
  name: "unmerge-contact",
  component: GenerateModalWithSuspense(UnmergeContactModal),
};

export default UnmergeContact;
